import React from 'react';

import {FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

export const GroupMembersSkeleton = () => (
    <FormItemSkeleton labelWidth={85}>
        <SkeletonItem width={600} height={32}/>
    </FormItemSkeleton>
);
